import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { fetchList } from 'services/capabilities/duck';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';


const Option = Select.Option;

class CapabilitySelectContainer extends Component {
    constructor(props) {
        super(props);

        this.scrollingArea = React.createRef();
    }
    componentDidMount() {
        this.props.fetchList();
    }

    onChange(input, value) {
        input.onChange(value.map(item => ({ id: item })));
    }

    static renderOptions(list) {
        return list.map((item, index) => (
            <Option key={index} value={item.id} searchtitle={item.name.toLowerCase()}>{item.name}</Option>
        ));
    }

    static filter(inputValue, node) {
        return node.props.searchtitle.includes(inputValue.toLowerCase());
    }

    render() {
        const { input } = this.props;

        if (this.props.list && this.props.list.length) {
            let currentValue = get(input, 'value', []);

            if (!Array.isArray(currentValue)) {
                currentValue = [];
            }

            return (
                <div ref={this.scrollingArea} style={{ width: '100%' }}>
                    <Select
                        mode="multiple"
                        showSearch
                        onChange={this.onChange.bind(this, input)}
                        filterOption={CapabilitySelectContainer.filter}
                        style={{ width: '100%', marginBottom: '20px' }}
                        dropdownStyle={{ overflow: 'auto', maxHeight: '40vh' }}
                        getPopupContainer={() => this.scrollingArea.current}
                        value={currentValue.map(item => item.id)}
                    >
                        {CapabilitySelectContainer.renderOptions(this.props.list)}
                    </Select>
                </div>
            );
        }

        return null;
    }
}

const mapStateToProps = state => ({
    list: state.capabilities.list
});

export { CapabilitySelectContainer as __InternalClass };

export default connect(mapStateToProps, { fetchList })(CapabilitySelectContainer);



// WEBPACK FOOTER //
// ./src/containers/CapabilitySelectContainer.js